module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "layoutTop"
  }), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', [_c('back-button', {
    attrs: {
      "returnUrl": '/administration/accounts/'
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "showLargeScreenOnly",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "md": "3"
    },
    on: {
      "click": function($event) {
        return _vm.onRefresh()
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "refresh"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fab-label"
  }, [_vm._v(_vm._s(_vm.$t('common.rfrsh')))])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "tableHeaderColored text-center"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('administration.users_list')) + " ")])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('f7-searchbar', {
    attrs: {
      "cancel-link": _vm.$t('common.cncl'),
      "placeholder": "Search in Users",
      "search-list": "#users-list"
    },
    on: {
      "searchbar:search": _vm.onUsersSearch,
      "searchbar:clear": _vm.onUsersClear
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "itemList"
  }, [(_vm.usersList.length === 0) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.usersList) ? _c('f7-list', {
    attrs: {
      "media-list": "",
      "id": "users-list"
    }
  }, [_c('f7-list-item', [_c('b-row', [_c('b-col', {
    staticClass: "text-center boldLabel"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('administration.user_id') + ' :') + "\n                  ")]), _vm._v(" "), _c('b-col', {
    staticClass: "text-center boldLabel"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('administration.user_login') + ' :') + "\n                  ")])], 1)], 1), _vm._v(" "), _vm._l((_vm.usersList), function(usersGroup, key) {
    return _c('f7-list', {
      key: key,
      attrs: {
        "media-list": ""
      }
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _vm._l((usersGroup), function(user) {
      return _c('f7-list-item', {
        key: user.Id,
        class: {
          'boxRequest': _vm.canGetUserAccountDetail()
        }
      }, [_c('b-row', {
        on: {
          "click": function($event) {
            _vm.canGetUserAccountDetail() ? _vm.seeDetails(user) : _vm.seeDetails()
          }
        }
      }, [_c('b-col', {
        staticClass: "text-center"
      }, [_vm._v("\n                      " + _vm._s(user.Id) + "\n                    ")]), _vm._v(" "), _c('b-col', {
        staticClass: "text-center"
      }, [_vm._v("\n                      " + _vm._s(user.Login) + "\n                    ")])], 1)], 1)
    })], 2)
  })], 2) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6d3ce5d0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d3ce5d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/administration/CompanyPage.vue
// module id = 2391
// module chunks = 2